<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>

<div class="container">
    <div class="row">
        <div class="col-24">
            <h1>License Information</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-24" *ngIf="licExpMessageAvailable" [innerHTML]="licExpMessage">            </div>
        <div class="col-24" *ngIf="showDefaultMessage">
                <p class="bottom-20">Our records show that your insurance license has expired in the following state(s). If you plan to market in the state(s), please send an updated copy of your license(s) to your administrator at your earliest convenience. If you no longer plan to market in the state(s), click on the Edit link on right hand side, uncheck the Active box and click on the Update link. Thank your for your support!</p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <table class="table-text-small">
                <thead>
                    <tr>
                        <th>State</th>
                        <th>State License #</th>
                        <th>License Expiration Date</th>
                        <th>License Status</th>
                        <th>Source</th>                        
                        <th *ngIf="showAppt">Appointment Date</th>
                        <th *ngIf="showAppt">Appointment Termination Date</th>
                        <th *ngIf="showAppt">Appointment Status</th>
                        <!--  <th *ngIf="superGuruAdmin">Actions</th>-->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let l of licenseViewModel">
                        <td>
                            {{l.StateAbbr}}
                        </td>
                        <td>{{l.LicenseNumber}}</td>
                        <td>{{l.LicenseExpirationDate}}</td>
                        <td>{{l.Status}}</td>
                        <td>{{l.Source}}</td>
                        <td *ngIf="showAppt">{{l.AppointmentEffectiveDate}}</td>
                        <td *ngIf="showAppt">{{l.AppointmentTerminationDate}}</td>
                        <td *ngIf="showAppt">{{l.AppointmentStatusName}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="row" *ngIf="!loading">
        <div class="col-24">
            <button id="continue" class="button primary" (click)="continue()">Continue</button>
        </div>
    </div>
</div>





        <!-- <td>
            <div *ngIf="l.EditRow && index==i;else other_content_licenseNumber">

            </div>

            <ng-template #other_content_licenseNumber>{{l.LicenseNumber}}</ng-template>

            <input type="text" name="LicenseNumber{{i}}" id="LicenseNumber{{i}}" [(ngModel)]="licenseViewModel[i].LicenseNumber" *ngIf="l.EditRow && index==i"
                   value="{{l.LicenseNumber}}" />
        </td>
        <td>
            <div *ngIf="l.EditRow && index==i;else other_content_licenseExpirationDate">

            </div>

            <ng-template #other_content_licenseExpirationDate>{{l.LicenseExpirationDate}}</ng-template>
            <input type="text" name="LicenseExpirationDate{{i}}" id="LicenseExpirationDate{{i}}" [(ngModel)]="licenseViewModel[i].LicenseExpirationDate" *ngIf="l.EditRow && index==i"
                   value="{{l.LicenseExpirationDate}}" />

        </td>

        <td>
            <div *ngIf="l.EditRow && index==i;else other_content_licenseStatusId">

            </div>

            <ng-template #other_content_licenseStatusId>{{l.Status}}</ng-template>


            <select name="LicenseStatusId{{i}}" id="LicenseStatusId{{i}}" [(ngModel)]="licenseViewModel[i].Status" *ngIf="l.EditRow && index==i">
                <option *ngFor="let licStatus of allLicenseStatus" value={{licStatus.LicenseStatus}}>
                    {{licStatus.LicenseStatus}}
                </option>
            </select>

        </td> -->
        <!--
        <td *ngIf="superGuruAdmin">
            <button id="delete" (click)="deleteLicense(l.LicenseID, l.UserProfileID)">Delete</button>
            <button id="edit" (click)="editLicense(l.LicenseID, i,l.LicenseNumber,l)" *ngIf="!l.EditRow">Edit</button>
            <button id="save" (click)="saveRowLicense(licenseViewModel[i],i)" *ngIf="l.EditRow && index==i">Save</button>
            <button id="appoint" (click)="appointLicense(l.LicenseID, l.UserProfileID,l.AppointmentStatusName)" *ngIf="l.appoint">Apoint</button>
            <button id="confirmappoint" (click)="confirmappointLicense(l.LicenseID, l.UserProfileID)" *ngIf="l.cfmappoint">Confirm Appointment</button>
            <button id="terminate" (click)="terminateLicense(l.LicenseID, l.UserProfileID)" *ngIf="l.terminate">Terminate</button>
            <button id="cfmterminate" (click)="cfmterminateLicense(l.LicenseID, l.UserProfileID)" *ngIf="l.cfmterminate">Confirm Termination</button>
        </td>-->
        <!--
                        <tr *ngIf="saveRow">
                            <td>


                                <select [(ngModel)]="licenseInsertModel.StateAbbr" id="StateAbbr" name="StateAbbr">
                                    <option *ngFor="let state of allStates" value={{state.value}}>
                                        {{state.value}}
                                    </option>
                                </select>
                            </td>
                            <td><input type="text" [(ngModel)]="licenseInsertModel.LicenseNumber" id="LicenseNumber" name="LicenseNumber" /></td>
                            <td><input type="text" [(ngModel)]="licenseInsertModel.LicenseExpirationDate" id="LicenseExpirationDate" name="LicenseExpirationDate" placeholder="mm/dd/yyyy" /></td>
                            <td>

                                <select [(ngModel)]="licenseInsertModel.LicenseStatusId" id="LicenseStatusId" name="LicenseStatusId">
                                    <option *ngFor="let licStatus of allLicenseStatus" value={{licStatus.LicenseStatusID}}>
                                        {{licStatus.LicenseStatus}}
                                    </option>
                                </select>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--
        <div class="row">
            <div class="col-24" *ngIf="superGuruAdmin">
                <button id="addRow" (click)="addNewRow()" *ngIf="!saveRow" class="button primary">Add New Row</button>
                <button id="saveNewRow" (click)="saveLicense()" *ngIf="saveRow" class="button primary">Save License</button>
            </div>-->
        <!--
            <div class="row">
                <div class="col-24" *ngIf="showMessage">
                    <p>{{savedMessage}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-24" *ngIf="showConfirmDelete">
                    <!--<div>
                    <strong>
                        <a id="lnkCancel" (click)="cancelStatusUpdate()" >X</a>
                    </strong>
                </div>
                    <div id="messagedel"><p id="currentDate">{{displayMessage}}</p></div>
                    <div>
                        <button class="button primary" name="btnDeleteConfirm" id="DeleteConfirm" *ngIf="updateLicense" (click)="updateLicenseStatus()">Confirm</button>
                        <button class="button primary" id="delete" *ngIf="!updateLicense" (click)="deleteLicenseData()">Confirm Delete</button>
                        <button class="button cancel" id="lnkCancelBtn" (click)="cancelStatusUpdate()">Cancel</button>
                    </div>
                </div>
            </div>
            -->




